export default {
  video: {
    desc: 'Your Secure Crypto Hardware Wallet',
    preOrderNow: 'Buy',
    watchNow: 'Watch Now',
  },

  introduce: {
    title:
      'Combining Security and Ease of Use, with Advantages in Full Display',
    desc_1: 'Click any card to learn more',
    desc_2: 'Connection',
    desc_3: 'Security',
    desc_4: 'Backup',
    desc_5: 'Passphrase',
    desc_6: 'Battery Life',
    desc_7: 'Capacity',
    desc_8: 'Dual-Chip',
    desc_9: '15-Key Layout',
    desc_10: 'Multiple ways to connect, there’s one that’s right for you',
    desc_11: 'NFC + KeyPal Card',
    desc_12: 'Usage',
    label_1:
      'Supports Bluetooth and QR code scanning for wallet connection and transaction signing',
    label_1_1:
      'Choose different connection methods according to different scenarios, making hardware wallet usage safer and more convenient',
    label_2: 'KeyPal 2 supports Passphrase',
    label_2_1:
      'With the same set of recovery phrases, you can access different wallets by using different Passphrases, adding an extra layer of security to your wallet',
    label_3: 'Supports NFC for simpler, faster backups',
    label_3_1:
      'KeyPal 2 allows you to quickly back up your recovery phrase to the KeyPal Card via NFC',
    label_4: 'Larger battery capacity, upgraded from 300 mAh to 500 mAh',
    label_4_1:
      'One charge lasts up to 12 hours, keeping you free from low-battery anxiety',
    label_5: 'KeyPal 2 adopts a military-grade dual-chip design',
    label_5_1: 'With MCU + SE architecture, security starts from the core',
    label_6: '15-key grid for simpler input and interaction',
    label_6_1:
      'Enter content and select functions quickly, without long and complicated steps',
  },

  support: {
    title: 'Millions of supported cryptos',
    desc_1: 'View Supported List',
  },

  other: {
    title: 'Other KeyPal Products',
    desc_1: `KeyPal Plus features a dual-chip architecture, combining ease of use and security. Its minimalist design style, paired with a robust aluminum alloy shell, delivers a durable and efficient digital asset management experience`,
    desc_2: `KeyPal Card supports NFC communication, allowing you to easily store your mnemonic phrases and private keys with a single tap. It perfectly combines offline backup and signing functions. With its credit card-sized design, it is portable, secure, and protects your crypto assets anytime, anywhere`,
    desc_3: `Secret Box is made from 304 stainless steel, offering exceptional resistance to high temperatures and corrosion. Its letter block and groove design make seed phrase storage simpler and more durable. With an A+B double-sided design, it supports storage for 12×2, 18, or 24-word seed phrases, providing long-term security for your crypto assets`,
  },

  FAQ: {
    title: 'FAQ',
    desc_1: 'Click to view answers to all FAQs',
    question_1: 'What is a crypto wallet?',
    question_2: 'Why do I need a wallet for crypto?',
    question_3: 'How is a hardware wallet different from an app?',
    question_4: 'How can I keep my crytpo safe if I lose the device?',
    question_5: 'What type of crypto can I use with this wallet?',
  },

  discover: {
    title: 'Choose Your Favorite KeyPal Colors',
    desc_1: 'Discover',
  },

  instructions: {
    title: 'Tutorial Center',
    desc: 'Comprehensive demos to help you master KeyPal 2 with ease, making crypto asset management simple and secure.',
    tabs: {
      hardware: 'Device Features',
      activation: 'Device Tutorial',
      connect: 'Connect Wallet',
      upgrade: 'Firmware Upgrade',
    },
    hardware: {
      basic: 'Basic Operations',
      power: 'Power On/Off',
      language: 'Language Selection',
      button: 'Button Operation',
      features: 'Function Overview',
      security: 'Security Settings',
      passphrase: 'Passphrase Setup',
      securityOverview: 'Security Settings Overview',
      verifyDevice: 'Verify Device',
      asset: 'Asset Management',
    },
    activation: {
      create: 'Create Mnemonic Phrase',
      createByDevice: 'Create Mnemonic Phrase on Device',
      import: 'Import Mnemonic Phrase',
      manualImport: 'Manual Import',
      keypalCardImport: 'Import via KeyPal Card',
      backup: 'Backup Mnemonic Phrase',
      steelBackup: 'Write-down / Secret Box Backup',
      keypalCardBackup: 'KeyPal Card Backup',
    },
    connect: {
      bluetooth: 'Connect to TokenPocket via Bluetooth',
      connectAndAdd: 'Connect App & Add Wallet Address',
      qrConnect: 'QR Scan Connect',
      qrConnectTP: 'Scan to Connect TokenPocket',
      qrConnectMM: 'Scan to Connect MetaMask',
      transferReceive: 'Transfer & Receive',
      receiveHardware: 'Receive via Hardware',
      receiveApp: 'Receive via App',
      transfer: 'Transfer',
    },
    upgrade: {
      web: 'Upgrade via Web',
      bluetooth: 'Upgrade via Bluetooth',
      mobile: 'Mobile App Upgrade',
      troubleshoot: 'Firmware Upgrade Troubleshooting',
      webTroubleshoot: 'Firmware Upgrade via Web Troubleshooting',
      bluetoothTroubleshoot: 'Firmware Upgrade via Bluetooth Troubleshooting',
    },
    relatedVideos: 'Related Videos',
    playing: 'Playing',
  },
};
